module.exports = __webpack_public_path__ + "static/media/sample_04.b7e8e2ff.jpg";